var shownProductIds = {};

function getCartItems()
{
    var items = [];

    if (window.Shopify && window.Shopify.cart && window.Shopify.cart.items)
    {
        items = window.Shopify.cart.items;
    }

    return items;
}

function refreshShopifyCartSnapshot(cartData)
{
    if (cartData && cartData.items && window.Shopify && window.Shopify.cart)
    {
        window.Shopify.cart = cartData;
        return;
    }

    fetch("/cart.js", {
        method: "GET",
        headers: { "Accept": "application/json" }
    })
    .then(function(response)
    {
        return response.json();
    })
    .then(function(freshCart)
    {
        if (freshCart && freshCart.items && window.Shopify && window.Shopify.cart)
        {
            window.Shopify.cart = freshCart;
        }
    })
    .catch(function() {});
}

function getActiveCartSectionName()
{
    if (document.getElementById("shopify-section-welleasy-new-old-cart"))
    {
        return "welleasy-new-old-cart";
    }

    return "welleasy-new-cart-template";
}

function recheckAllRecsQtyState()
{
    var containers = document.querySelectorAll("[data-buy-it-again-track], [data-recent-track], .healthy-home-products-container, .members-love-products");

    for (var i = 0; i < containers.length; i++)
    {
        checkCartQtyState(containers[i]);
    }
}

function isMembershipProduct(item)
{
    var result = false;

    if (item)
    {
        var recEl = document.querySelector(".healthy-home-recommendations");

        if (recEl)
        {
            var annualId  = recEl.getAttribute("data-annual-subscription-id");
            var monthlyId = recEl.getAttribute("data-monthly-subscription-id");
            var legacyId  = recEl.getAttribute("data-legacy-subscription-id");
            var pid       = String(item.product_id || "");

            if (annualId && pid == annualId)  { result = true; }
            if (monthlyId && pid == monthlyId) { result = true; }
            if (legacyId && pid == legacyId)   { result = true; }
        }
    }

    return result;
}

function isGiftProduct(item)
{
    var result = false;

    if (item)
    {
        result = item.properties && item.properties._product_gift_type ? true : false;
    }

    return result;
}

function isProductInCategoryByHandle(item, categoryHandle)
{
    var result = false;

    if (item && item.product && item.product.collections)
    {
        for (var i = 0; i < item.product.collections.length; i++)
        {
            if (item.product.collections[i].handle == categoryHandle)
            {
                result = true;
            }
        }
    }

    return result;
}

function updateCategoryTabActiveState(categoryHandle, isActive)
{
    var tab = document.querySelector(".healthy-home-tab[data-category=\"" + categoryHandle + "\"]");

    if (tab)
    {
        if (isActive)
        {
            tab.classList.add("active");
            tab.setAttribute("aria-selected", "true");
        }
        else
        {
            tab.classList.remove("active");
            tab.setAttribute("aria-selected", "false");
        }
    }
}

function checkHealthyHomeCategories()
{
    var cartItems       = getCartItems();
    var categoryHandles = ["food", "snacks", "drinks", "supplements", "household", "personal-care"];

    for (var i = 0; i < categoryHandles.length; i++)
    {
        var handle     = categoryHandles[i];
        var hasCategory = false;

        for (var j = 0; j < cartItems.length; j++)
        {
            var item = cartItems[j];

            if (isMembershipProduct(item)) { continue; }
            if (isGiftProduct(item)) { continue; }

            if (isProductInCategoryByHandle(item, handle))
            {
                hasCategory = true;
            }
        }

        updateCategoryTabActiveState(handle, hasCategory);
    }
}

function initHealthyHomeTabListeners()
{
    var tabLists = document.querySelectorAll(".healthy-home-tab-list");
    var i = 0;

    for ( i = 0; i < tabLists.length; i++ )
    {
        if ( !tabLists[ i ]._hhTabsBound )
        {
            tabLists[ i ]._hhTabsBound = true;
            InitHealthyHomeTabList( tabLists[ i ] );
        }
    }
}

function InitHealthyHomeTabList( tabList )
{
    var tabs = tabList.querySelectorAll(".healthy-home-tab");

    for (var i = 0; i < tabs.length; i++)
    {
        tabs[i].addEventListener("click", function HealthyHomeTab_Click(event)
        {
            var targetTab = event.currentTarget;
            var tabHandle = targetTab.getAttribute("data-category");
            var tabRoot = targetTab.closest(".healthy-home-recommendations, .healthy-home-recommendations-ec");
            var scopeRoot = tabRoot ? tabRoot : document;
            var allTabs = scopeRoot.querySelectorAll(".healthy-home-tab");
            var tabHandles = [];

            if (!tabHandle)
            {
                return;
            }

            for (var t = 0; t < allTabs.length; t++)
            {
                tabHandles.push(allTabs[t].getAttribute("data-category"));
            }

            var targetIndex = tabHandles.indexOf(tabHandle);

            if (targetIndex != -1)
            {
                switchHealthyHomeTab(targetIndex, scopeRoot);
            }
        });
    }
}

function switchHealthyHomeTab(tabIndex, tabRoot)
{
    var root = tabRoot || document;
    var tabs   = root.querySelectorAll(".healthy-home-tab");
    var panels = root.querySelectorAll(".healthy-home-panel");

    for (var i = 0; i < tabs.length; i++)
    {
        tabs[i].classList.toggle("active", i == tabIndex);
        tabs[i].setAttribute("aria-selected", i == tabIndex ? "true" : "false");
    }

    for (var i = 0; i < panels.length; i++)
    {
        panels[i].classList.toggle("hidden", i != tabIndex);
    }

    var activePanel = panels[tabIndex];

    if (activePanel && !activePanel.getAttribute("data-loaded"))
    {
        var skipQuiz = tabIndex >= 3;
        loadProductsForPanel(activePanel, skipQuiz);
    }
}

var healthyHomeCollectionCache = { };
var healthyHomeCollectionInflight = { };

function fetchCollectionProducts(categoryHandle, callback)
{
    var url = "/collections/" + categoryHandle + "/products.json?limit=60&sort_by=best-sellers";
    var retried = false;
    var cached = null;
    var waiting = null;

    if ( categoryHandle )
    {
        cached = healthyHomeCollectionCache[ categoryHandle ];
    }
    if ( cached )
    {
        callback( null, cached );
        return;
    }

    if ( categoryHandle )
    {
        waiting = healthyHomeCollectionInflight[ categoryHandle ];
    }
    if ( waiting )
    {
        waiting.push( callback );
        return;
    }

    if ( categoryHandle )
    {
        healthyHomeCollectionInflight[ categoryHandle ] = [ callback ];
    }

    function finishAll( err, products )
    {
        var list = [ ];
        var i = 0;
        if ( categoryHandle && healthyHomeCollectionInflight[ categoryHandle ] )
        {
            list = healthyHomeCollectionInflight[ categoryHandle ];
            delete healthyHomeCollectionInflight[ categoryHandle ];
        }
        else if ( !categoryHandle )
        {
            list = [ callback ];
        }
        if ( !err && categoryHandle )
        {
            healthyHomeCollectionCache[ categoryHandle ] = products;
        }
        for ( i = 0; i < list.length; i++ )
        {
            list[ i ]( err, products );
        }
    }

    function doFetch()
    {
        var xhr = new XMLHttpRequest();

        xhr.open("GET", url, true);

        xhr.onreadystatechange = function HealthyHomeFetch_ReadyState()
        {
            if (xhr.readyState == 4)
            {
                var body = xhr.responseText || "";

                if (xhr.status == 429 && !retried)
                {
                    var waitMs = 15000;
                    var retryAfter = xhr.getResponseHeader("Retry-After");
                    var waitSecs = parseInt(retryAfter || "", 10);
                    retried = true;
                    if (!isNaN(waitSecs))
                    {
                        waitMs = Math.min(Math.max(waitSecs * 1000, 5000), 60000);
                    }
                    setTimeout(doFetch, waitMs);
                    return;
                }

                if (body.charAt(0) == "<" || body.indexOf("<html") != -1)
                {
                    finishAll(new Error("HTML response"), []);
                    return;
                }

                try
                {
                    var data = JSON.parse(body);
                    var products = data.products || [];
                    finishAll(null, products);
                }
                catch (e)
                {
                    finishAll(e, []);
                }
            }
        };

        xhr.send();
    }

    doFetch();
}

function getDiscountPercentage(compareAtPrice, price)
{
    var compare = parseFloat(compareAtPrice);
    var current = parseFloat(price);
    var discount = 0;

    if (compare > 0 && compare > current)
    {
        discount = Math.round(((compare - current) / compare) * 100);
    }

    return discount;
}

function renderStarRating()
{
    var html = "<span class=\"healthy-home-product-card-stars\">";

    for (var s = 0; s < 5; s++)
    {
        html += "<svg width=\"12\" height=\"12\" viewBox=\"0 0 24 24\" fill=\"#FFB800\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 2L14.09 8.26L20 9.27L15.55 13.97L16.91 20L12 16.9L7.09 20L8.45 13.97L4 9.27L9.91 8.26L12 2Z\"/></svg>";
    }

    html += "</span>";

    return html;
}

var healthyHomeEcWidgets = {
    "food" : "Quiz Recs - Food",
    "household" : "Quiz Recs - Home",
    "supplements" : "Quiz Recs - Supplements",
    "personal-care" : "Quiz Recs - Personal",
    "snacks" : "Quiz Recs - Snacks",
    "drinks" : "Quiz Recs - Drinks"
};

function normalizeEcWidgetProduct( ecProduct )
{
    var normalized = null;
    var variants = [];
    var images = [];
    var rawImages = [];
    var imageSrc = "";
    var v = 0;
    var i = 0;

    if ( !ecProduct )
    {
        return normalized;
    }

    if ( ecProduct.variants )
    {
        for ( v = 0; v < ecProduct.variants.length; v++ )
        {
            variants.push( {
                id : ecProduct.variants[ v ].id,
                price : String( ( ecProduct.variants[ v ].price / 100 ).toFixed( 2 ) ),
                compare_at_price : ecProduct.variants[ v ].compare_at_price ? String( ( ecProduct.variants[ v ].compare_at_price / 100 ).toFixed( 2 ) ) : null,
                available : ecProduct.variants[ v ].available == true,
                inventory_quantity : ecProduct.variants[ v ].inventory_quantity
            } );
        }
    }

    if ( ecProduct.feature_image )
    {
        imageSrc = ecProduct.feature_image;
    }
    else if ( ecProduct.featured_image )
    {
        imageSrc = ecProduct.featured_image.src || ecProduct.featured_image;
    }

    rawImages = ecProduct.images || [];

    for ( i = 0; i < rawImages.length; i++ )
    {
        images.push( { src : rawImages[ i ].src || rawImages[ i ] } );
    }

    if ( images.length == 0 && imageSrc != "" )
    {
        images.push( { src : imageSrc } );
    }

    normalized = {
        id : ecProduct.id,
        handle : ecProduct.handle,
        title : ecProduct.title || "",
        vendor : ecProduct.vendor || "",
        tags : ecProduct.tags || [],
        images : images,
        variants : variants
    };

    return normalized;
}

function loadEcPoolIntoPanel( panel, widgetName, callback )
{
    var productsContainer = panel.querySelector( ".healthy-home-panel-products" );
    var wrapper = document.createElement( "div" );
    var widget = null;
    var tries = 0;
    var expectedCount = -1;
    var responseReceived = false;

    wrapper.style.display = "none";
    wrapper.setAttribute( "loading", "eager" );

    if ( !window.EC_CreateWidget )
    {
        if ( panel.getAttribute( "data-ec-pending" ) == "1" )
        {
            return;
        }

        panel.setAttribute( "data-ec-pending", "1" );

        function EcPool_EcReady( )
        {
            window.removeEventListener( "enhancedcommerce:ready", EcPool_EcReady );
            panel.removeAttribute( "data-ec-pending" );
            loadEcPoolIntoPanel( panel, widgetName, callback );
        }

        window.addEventListener( "enhancedcommerce:ready", EcPool_EcReady );

        /* JUSTIFIED: EC embed loads async and may be blocked; bounded wait falls back to products.json instead of stranding the tab. */
        setTimeout( function EcPool_EcWaitTimeout( )
        {
            if ( panel.getAttribute( "data-ec-pending" ) == "1" )
            {
                window.removeEventListener( "enhancedcommerce:ready", EcPool_EcReady );
                panel.removeAttribute( "data-ec-pending" );
                callback( null, [] );
            }
        }, 10000 );

        return;
    }

    panel.removeAttribute( "data-ec-pending" );

    widget = EC_CreateWidget( {
        "type" : "best_sellers",
        "name" : widgetName,
        "title" : "",
        "productsToShow" : "60"
    }, function EcPool_WidgetResponse( widget )
    {
        var count = widget && widget.products ? widget.products.length : 0;
        var err = widget && widget.error ? widget.error : null;
        console.log( "[Recs Debug] EC widget response:", widgetName, "| products:", count, "| error:", err );
        expectedCount = count;
        responseReceived = true;
    } );

    wrapper.appendChild( widget );

    if ( productsContainer )
    {
        productsContainer.appendChild( wrapper );
    }
    else
    {
        document.body.appendChild( wrapper );
    }

    function pollEcPoolCards( )
    {
        var ecCards = wrapper.querySelectorAll( ".ec-product-card, .product-grid__product-card" );
        var products = [];
        var i = 0;
        var atcBtn = null;
        var normalized = null;

        tries++;

        if ( responseReceived && expectedCount == 0 )
        {
            console.log( "[Recs Debug] EC wrapper children:", wrapper.childElementCount, "| HTML length:", wrapper.innerHTML.length );
            wrapper.remove( );
            callback( null, [] );
            return;
        }

        if ( ( ecCards.length > 0 && ( expectedCount == -1 || ecCards.length >= expectedCount ) ) || tries >= 50 )
        {
            if ( ecCards.length == 0 )
            {
                console.log( "[Recs Debug] EC wrapper children:", wrapper.childElementCount, "| HTML length:", wrapper.innerHTML.length );
            }

            console.log( "[Recs Debug] EC cards rendered:", ecCards.length, "| expected:", expectedCount );
            for ( i = 0; i < ecCards.length; i++ )
            {
                atcBtn = ecCards[ i ].querySelector( ".ec-add-to-cart" );
                normalized = null;

                if ( atcBtn && atcBtn._product )
                {
                    normalized = normalizeEcWidgetProduct( atcBtn._product );
                }

                if ( normalized && normalized.handle )
                {
                    products.push( normalized );
                }
            }

            wrapper.remove( );
            callback( null, products );
            return;
        }

        setTimeout( pollEcPoolCards, 100 );
    }

    pollEcPoolCards( );
}

function renderHealthyHomeProductCard(product, quizTags)
{
    var featuredImage = product.images && product.images.length > 0 ? product.images[0].src : "";
    var productUrl    = "/products/" + product.handle;
    var variant       = product.variants && product.variants.length > 0 ? product.variants[0] : null;
    var price         = variant ? variant.price : "0";
    var compareAtPrice = variant ? variant.compare_at_price : null;
    var vendor        = product.vendor || "";
    var variantId     = variant ? variant.id : "";
    var isAvailable   = variant ? variant.available : false;
    var inventoryQty  = variant && variant.inventory_quantity != null ? String( variant.inventory_quantity ) : "";
    var discountPct   = getDiscountPercentage(compareAtPrice, price);
    var reviewCount   = Math.floor(Math.random() * 20) + 5;
    var productDataJson = JSON.stringify({ url: productUrl });

    var html = "<div class=\"healthy-home-product-card we-quiz-card\" data-product-data=\"" + productDataJson.replace(/"/g, "&quot;") + "\">";

    html += "<div class=\"healthy-home-product-card-image\">";

    if (discountPct > 0)
    {
        html += "<span class=\"healthy-home-product-card-badge\">" + discountPct + "% off</span>";
    }

    html += "<button type=\"button\" class=\"healthy-home-product-card-heart\" aria-label=\"Add to wishlist\">";
    html += "<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>";
    html += "</button>";

    if (featuredImage)
    {
        html += "<img class=\"we-quiz-card__image-img\" src=\"" + featuredImage + "\" alt=\"" + (product.title || "") + "\" loading=\"lazy\" width=\"200\" height=\"200\">";
    }

    if (variantId && isAvailable)
    {
        html += "<button class=\"healthy-home-product-card-atc\" data-variant-id=\"" + variantId + "\" data-inventory-quantity=\"" + inventoryQty + "\" type=\"button\">";
        html += "<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 5V19M5 12H19\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>";
        html += "</button>";
    }

    html += "</div>";

    html += "<div class=\"healthy-home-product-card-info\">";
    html += "<p class=\"healthy-home-product-card-vendor we-quiz-card__vendor\">" + vendor + "</p>";
    html += "<h4 class=\"healthy-home-product-card-title we-quiz-card__title\">" + (product.title || "") + "</h4>";

    html += "<div class=\"healthy-home-product-card-rating\">";
    html += renderStarRating();
    html += "<span class=\"healthy-home-product-card-review-count\">(" + reviewCount + ")</span>";
    html += "</div>";

    html += "<div class=\"healthy-home-product-card-price\">";

    if (discountPct > 0 && compareAtPrice)
    {
        html += "<span class=\"healthy-home-product-card-compare\">(RRP £" + parseFloat(compareAtPrice).toFixed(2) + ")</span>";
    }

    html += "<span class=\"healthy-home-product-card-regular\">£" + parseFloat(price).toFixed(2) + "</span>";
    html += "</div>";

    var productTags = product.tags || [];
    var matchedTags = [];

    for (var t = 0; t < productTags.length; t++)
    {
        var tagLower = productTags[t].toLowerCase();

        for (var q = 0; q < quizTags.length; q++)
        {
            if (tagLower == quizTags[q])
            {
                matchedTags.push(productTags[t]);
            }
        }
    }

    if (matchedTags.length > 0)
    {
        html += "<div class=\"healthy-home-product-card-tags\">";

        for (var m = 0; m < matchedTags.length && m < 2; m++)
        {
            html += "<span class=\"healthy-home-product-card-tag\">" + matchedTags[m] + "</span>";
        }

        html += "</div>";
    }

    html += "<button type=\"button\" class=\"we-quiz-card__reason healthy-home-product-card-picked\" aria-expanded=\"false\">";
    html += "<svg width=\"12\" height=\"12\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 2L14.09 8.26L20 9.27L15.55 13.97L16.91 20L12 16.9L7.09 20L8.45 13.97L4 9.27L9.91 8.26L12 2Z\" fill=\"currentColor\"></path></svg>";
    html += "Picked for you - see why \u2192";
    html += "</button>";

    html += "</div>";
    html += "</div>";

    return html;
}

function productMatchesQuizTags(product, quizTags)
{
    var result = true;

    if (quizTags && quizTags.length > 0)
    {
        var productTags = product.tags || [];
        result = false;

        for (var t = 0; t < productTags.length; t++)
        {
            var tagLower = productTags[t].toLowerCase();

            for (var q = 0; q < quizTags.length; q++)
            {
                if (tagLower == quizTags[q])
                {
                    result = true;
                }
            }
        }
    }

    return result;
}

function getQuizTags()
{
    var quizState = {};

    try
    {
        var savedStr = window.localStorage.getItem("welleasy_onboarding_quiz_state");

        if (savedStr && savedStr.length > 0)
        {
            quizState = JSON.parse(savedStr);
        }
    }
    catch (e) {}

    var slides   = window._onboardingQuizData && window._onboardingQuizData.slides ? window._onboardingQuizData.slides : [];
    var csKeyMap = window._onboardingQuizData && window._onboardingQuizData._csKeyMap ? window._onboardingQuizData._csKeyMap : {};
    var tags     = [];

    for (var key in quizState)
    {
        if (quizState.hasOwnProperty(key) && quizState[key] && quizState[key].length > 0)
        {
            var slide = null;

            for (var s = 0; s < slides.length; s++)
            {
                if (slides[s].key == key)
                {
                    slide = slides[s];
                }
            }

            if (!slide && csKeyMap.hasOwnProperty(key)) { slide = csKeyMap[key]; }

            if (slide && slide.answers)
            {
                var selectedValues = quizState[key];

                for (var v = 0; v < selectedValues.length; v++)
                {
                    var selectedVal = selectedValues[v];
                    var colonIdx    = selectedVal.indexOf(":");
                    var rawValue    = colonIdx >= 0 ? selectedVal.substring(0, colonIdx) : selectedVal;

                    for (var a = 0; a < slide.answers.length; a++)
                    {
                        if (slide.answers[a].value == rawValue && slide.answers[a].none != true)
                        {
                            var pt = (slide.answers[a].productTag || "").toLowerCase().trim();

                            if (pt)
                            {
                                tags.push(pt);
                            }
                        }
                    }
                }
            }
        }
    }

    return tags;
}

function fetchPickCount(categoryHandle, quizTags)
{
    var tag = document.querySelector(".quiz-areas-pick-count[data-category=\"" + categoryHandle + "\"]");

    if (tag)
    {
        fetchCollectionProducts(categoryHandle, function(err, products)
        {
            var count = 0;

            if (!err && products.length > 0)
            {
                if (quizTags.length == 0)
                {
                    count = products.length;
                }
                else
                {
                    for (var p = 0; p < products.length; p++)
                    {
                        var pv = products[p].variants && products[p].variants.length > 0 ? products[p].variants[0] : null;

                        if (pv && pv.available && productMatchesQuizTags(products[p], quizTags))
                        {
                            count++;
                        }
                    }
                }
            }

            tag.textContent = count;
        });
    }
}

function fetchUncoveredPickCounts()
{
    var quizTags = getQuizTags();
    var tags     = document.querySelectorAll(".quiz-areas-pick-count[data-category]");

    for (var i = 0; i < tags.length; i++)
    {
        var categoryHandle = tags[i].getAttribute("data-category");
        var panel          = document.querySelector(".healthy-home-panel[data-category=\"" + categoryHandle + "\"]");

        if (!panel || !panel.getAttribute("data-loaded"))
        {
            fetchPickCount(categoryHandle, quizTags);
        }
    }
}

function loadDrawerReviews(handle)
{
    var container = document.querySelector(".we-quiz-drawer__reviews");

    if (container)
    {
        container.innerHTML = "";

        fetch("/products/" + handle + ".js")
            .then(function HealthyHomeFetchProduct(r) { return r.json(); })
            .then(function HealthyHomeLoadReviews(product)
            {
                if (product && product.variants && product.variants.length > 0)
                {
                    var skus = [];

                    for (var v = 0; v < product.variants.length; v++)
                    {
                        var variant = product.variants[v];

                        if (variant.sku) { skus.push(variant.sku); }

                        skus.push(String(variant.id));
                    }

                    var skuString  = skus.join(";");
                    var scriptSrc  = "https://widget.reviews.co.uk/polaris/build.js";
                    var existing   = document.querySelector("script[src=\"" + scriptSrc + "\"]");

                    if (!existing)
                    {
                        var script    = document.createElement("script");
                        script.src    = scriptSrc;
                        document.head.appendChild(script);
                    }

                    function initReviewsWidget()
                    {
                        if (typeof ReviewsWidget == "undefined")
                        {
                            setTimeout(initReviewsWidget, 200);
                            return;
                        }

                        var widgetDiv = document.createElement("div");
                        widgetDiv.id  = "drawer-reviews-widget";
                        container.appendChild(widgetDiv);

                        new ReviewsWidget("#drawer-reviews-widget", {
                            store: "www.welleasy.co.uk",
                            widget: "polaris",
                            options: {
                                types: "product_review",
                                lang: "en",
                                layout: "",
                                per_page: 3,
                                product_review: {
                                    sku: skuString,
                                    hide_if_no_results: true
                                },
                                header: {
                                    enable_summary: true,
                                    enable_ratings: false,
                                    enable_attributes: false,
                                    enable_image_gallery: false,
                                    enable_percent_recommended: false,
                                    enable_write_review: false,
                                    enable_ask_question: false,
                                    enable_sub_header: false,
                                    rating_decimal_places: 2
                                },
                                filtering: {
                                    enable: false
                                },
                                reviews: {
                                    enable_avatar: true,
                                    enable_reviewer_name: true,
                                    enable_reviewer_address: false,
                                    enable_verified_badge: false,
                                    enable_reviewer_recommends: false,
                                    enable_attributes: false,
                                    enable_product_name: false,
                                    enable_review_title: true,
                                    enable_replies: false,
                                    enable_images: false,
                                    enable_ratings: false,
                                    enable_share: false,
                                    enable_helpful_vote: true,
                                    enable_helpful_display: false,
                                    enable_report: false,
                                    enable_date: true
                                }
                            },
                            styles: {
                                "--base-font-size": "14px",
                                "--common-button-font-family": "inherit",
                                "--common-button-font-size": "12px",
                                "--primary-button-bg-color": "#0ec4b9",
                                "--primary-button-border-color": "#0ec4b9",
                                "--primary-button-text-color": "#000",
                                "--secondary-button-bg-color": "#f2f2f2",
                                "--secondary-button-border-color": "#e5e7eb",
                                "--secondary-button-text-color": "#666",
                                "--common-star-color": "#FFB800",
                                "--common-star-disabled-color": "#e5e7eb",
                                "--medium-star-size": "16px",
                                "--small-star-size": "14px",
                                "--heading-text-color": "#111",
                                "--heading-text-font-weight": "700",
                                "--heading-text-font-size": "16px",
                                "--body-text-color": "#374151",
                                "--body-text-font-size": "13px",
                                "--body-text-line-height": "1.5",
                                "--common-border-color": "#f1f5f9",
                                "--avatar-thumbnail-size": "36px",
                                "--avatar-thumbnail-text-color": "#374151",
                                "--avatar-thumbnail-bg-color": "#e5e7eb"
                            }
                        });
                    }

                    initReviewsWidget();
                }
            })
            .catch(function HealthyHomeLoadReviewsError() {});
    }
}

function populateDrawerTags(drawer, productTags)
{
    var tagsContainer = drawer.querySelector(".we-quiz-drawer__tags");

    if (tagsContainer && productTags && productTags.length > 0)
    {
        tagsContainer.innerHTML = "";

        var quizState = {};

        try
        {
            var saved = localStorage.getItem("welleasy_onboarding_quiz_state");

            if (saved) { quizState = JSON.parse(saved); }
        }
        catch (e) {}

        var slides   = window._onboardingQuizData && window._onboardingQuizData.slides ? window._onboardingQuizData.slides : [];
        var csKeyMap = window._onboardingQuizData && window._onboardingQuizData._csKeyMap ? window._onboardingQuizData._csKeyMap : {};
        var starSvg  = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 2L14.09 8.26L20 9.27L15.55 13.97L16.91 20L12 16.9L7.09 20L8.45 13.97L4 9.27L9.91 8.26L12 2Z\" fill=\"currentColor\"/></svg>";

        var productTagsLower = [];

        for (var pt = 0; pt < productTags.length; pt++)
        {
            productTagsLower.push(productTags[pt].toLowerCase().trim());
        }

        for (var key in quizState)
        {
            if (quizState.hasOwnProperty(key) && quizState[key] && quizState[key].length > 0)
            {
                var isSubSlide     = csKeyMap.hasOwnProperty(key);
                var isBrandSlide   = key == "brands";
                var isPeopleCount  = key == "peopleCount";
                var isExcludedSlide = key == "goals" || key == "what_brings_you";

                if (!isSubSlide && !isBrandSlide && !isPeopleCount && !isExcludedSlide)
                {
                    var slide = null;

                    for (var s = 0; s < slides.length; s++)
                    {
                        if (slides[s].key == key) { slide = slides[s]; }
                    }

                    if (!slide && csKeyMap.hasOwnProperty(key)) { slide = csKeyMap[key]; }

                    if (slide && slide.answers)
                    {
                        var selectedValues = quizState[key];

                        for (var v = 0; v < selectedValues.length; v++)
                        {
                            var selectedVal = selectedValues[v];
                            var colonIdx    = selectedVal.indexOf(":");
                            var rawValue    = colonIdx >= 0 ? selectedVal.substring(0, colonIdx) : selectedVal;
                            var displayText = rawValue;
                            var productTag  = "";

                            for (var a = 0; a < slide.answers.length; a++)
                            {
                                if (slide.answers[a].value == rawValue)
                                {
                                    displayText = slide.answers[a].text;
                                    productTag  = (slide.answers[a].productTag || "").toLowerCase().trim();
                                }
                            }

                            if (productTag && productTagsLower.indexOf(productTag) != -1)
                            {
                                var tagEl = document.createElement("span");
                                tagEl.className = "we-quiz-drawer__tag";
                                tagEl.innerHTML = starSvg + displayText;
                                tagsContainer.appendChild(tagEl);
                            }
                        }
                    }
                }
            }
        }
    }
}

function openHealthyHomeDrawer(card)
{
    var drawer = document.getElementById("cartQuizDrawer");

    if (drawer)
    {
        var imgEl           = card.querySelector(".we-quiz-card__image-img");
        var vendorEl        = card.querySelector(".we-quiz-card__vendor");
        var titleEl         = card.querySelector(".we-quiz-card__title");
        var drawerImg       = drawer.querySelector(".we-quiz-drawer__img");
        var drawerIngredients = drawer.querySelector(".we-quiz-drawer__ingredients");
        var drawerNutrition = drawer.querySelector(".we-quiz-drawer__nutrition");
        var drawerVendor    = drawer.querySelector(".we-quiz-drawer__vendor");
        var drawerTitle     = drawer.querySelector(".we-quiz-drawer__title");
        var drawerWhyShown  = drawer.querySelector(".we-quiz-drawer__why-shown");

        var title  = titleEl ? (titleEl.textContent || "").trim() : "";
        var vendor = vendorEl ? (vendorEl.textContent || "").trim() : "";
        var imgSrc = imgEl ? imgEl.getAttribute("src") || "" : "";

        if (drawerImg) { drawerImg.src = imgSrc; drawerImg.alt = title; }
        if (drawerVendor) { drawerVendor.textContent = vendor; }
        if (drawerTitle) { drawerTitle.textContent = title; }

        var productDataStr = card.getAttribute("data-product-data") || "";
        var productUrl     = "";

        try
        {
            var productData = productDataStr ? JSON.parse(productDataStr) : null;

            if (productData && productData.url) { productUrl = productData.url; }
        }
        catch (err) {}

        var handleMatch = productUrl.match(/\/products\/([^/?]+)/);
        var handle      = handleMatch ? handleMatch[1] : "";

        if (handle)
        {
            fetch("/products/" + handle + ".js")
                .then(function HealthyHomeFetchProductForDrawer(r) { return r.json(); })
                .then(function HealthyHomePopulateDrawer(product)
                {
                    if (product.description && drawerIngredients) { drawerIngredients.innerHTML = product.description; }
                    if (product.vendor && drawerVendor) { drawerVendor.textContent = product.vendor; }

                    loadDrawerReviews(handle);
                })
                .catch(function HealthyHomeFetchProductForDrawerError() {});
        }

        if (drawerWhyShown) { drawerWhyShown.setAttribute("hidden", "hidden"); }

        var cardTagsStr = card.getAttribute("data-product-tags") || "";

        if (cardTagsStr)
        {
            populateDrawerTags(drawer, cardTagsStr.split(","));
        }
        else if (handle)
        {
            fetch("/products/" + handle + ".js")
                .then(function HealthyHomeFetchProductTags(r) { return r.json(); })
                .then(function HealthyHomePopulateDrawerTags(product)
                {
                    populateDrawerTags(drawer, product.tags || []);
                })
                .catch(function HealthyHomeFetchProductTagsError() {});
        }

        drawer.classList.add("we-quiz-drawer--open");
        drawer.setAttribute("aria-hidden", "false");
        document.body.classList.add("we-quiz-drawer-open");

        var backdrop = drawer.querySelector(".we-quiz-drawer-backdrop");

        if (backdrop) { backdrop.classList.add("we-quiz-drawer-backdrop--visible"); }
    }
}

function bindPickedButtons(container)
{
    var buttons = container.querySelectorAll(".we-quiz-card__reason");

    for (var i = 0; i < buttons.length; i++)
    {
        buttons[i].addEventListener("click", function HealthyHomePicked_Click(e)
        {
            e.preventDefault();
            e.stopPropagation();

            var btn  = e.currentTarget;
            var card = btn.closest(".we-quiz-card");

            if (card)
            {
                openHealthyHomeDrawer(card);
                btn.setAttribute("aria-expanded", "true");
            }
        });
    }
}

function initQuizAreasTagListeners()
{
    var tags = document.querySelectorAll(".quiz-areas-tag--add");

    for (var i = 0; i < tags.length; i++)
    {
        tags[i].addEventListener("click", function QuizAreasTag_Click(e)
        {
            e.preventDefault();

            var btn        = e.currentTarget;
            var categoryId = btn.getAttribute("data-category-id");

            if (categoryId)
            {
                var panel = document.querySelector(".healthy-home-panel[data-category=\"" + categoryId + "\"]");

                if (panel)
                {
                    var allTabs = document.querySelectorAll(".healthy-home-tab");

                    for (var t = 0; t < allTabs.length; t++)
                    {
                        if (allTabs[t].getAttribute("data-category") == categoryId)
                        {
                            allTabs[t].click();
                        }
                    }

                    setTimeout(function()
                    {
                        panel.scrollIntoView({ behavior: "smooth", block: "center" });
                    }, 100);
                }
            }
        });
    }
}

function loadProductsForPanel(panel, skipQuizFilter)
{
    var categoryHandle  = panel.getAttribute("data-category");
    var productsContainer = panel.querySelector(".healthy-home-panel-products");

    if (categoryHandle && productsContainer)
    {
        var loadingEl = document.createElement("div");
        loadingEl.className = "healthy-home-panel-loading";
        loadingEl.innerHTML = "<div class=\"healthy-home-panel-loading-spinner\"></div>";
        productsContainer.innerHTML = "";
        productsContainer.appendChild(loadingEl);

        var quizTags = getQuizTags();

        function HealthyHomeFetch_Products(err, products)
        {
            if (err || products.length == 0)
            {
                panel.setAttribute("data-loaded", "true");
                productsContainer.innerHTML = "<p class=\"healthy-home-panel-empty\">No products found in this category</p>";
                fetchUncoveredPickCounts();
                return;
            }

            panel.setAttribute("data-loaded", "true");

            var filtered = [];

            var noQuizCategories = ["supplements", "household", "personal-care"];
            var shouldSkipQuiz = skipQuizFilter || noQuizCategories.indexOf(categoryHandle) != -1;

            console.log( "[Recs Debug] Category:", categoryHandle, "| Quiz filter:", shouldSkipQuiz ? "SKIPPED" : "APPLIED", "| Tags:", quizTags.join( ", " ) );

            for (var i = 0; i < products.length; i++)
            {
                var fpv = products[i].variants && products[i].variants.length > 0 ? products[i].variants[0] : null;

                if (fpv && fpv.available && (shouldSkipQuiz || productMatchesQuizTags(products[i], quizTags)))
                {
                    filtered.push(products[i]);
                }
            }

            console.log( "[Recs Debug] Category:", categoryHandle, "| After quiz filter:", filtered.length, "products" );

            var deduped = [];
            for (var d = 0; d < filtered.length; d++)
            {
                if (!shownProductIds[filtered[d].id])
                {
                    deduped.push(filtered[d]);
                }
            }
            filtered = deduped;

            console.log( "[Recs Debug] Category:", categoryHandle, "| After dedup:", filtered.length, "products" );

            buildL3ProductMap( function OnL3MapReady( l3Map )
            {
                var before = filtered.length;

                if ( panel.getAttribute( "data-ec-pool" ) == "1" )
                {
                    console.log( "[Recs Debug] Category:", categoryHandle, "| L3 cap skipped (EC pool)" );
                }
                else
                {
                    filtered = applyL3Cap( filtered, l3Map, buildL3ProductMap._limits || [] );
                }
                console.log( "[Recs Debug] Category:", categoryHandle, "| After L3 cap:", filtered.length, "products (was " + before + ")" );

            // Diversity pass: round-robin by vendor (brand)
            var typeGroups = {};
            var typeOrder = [];
            for (var g = 0; g < filtered.length; g++)
            {
                var pType = filtered[g].vendor || "other";
                if ( !typeGroups[pType] )
                {
                    typeGroups[pType] = [];
                    typeOrder.push(pType);
                }
                typeGroups[pType].push(filtered[g]);
            }

            if ( typeOrder.length > 1 )
            {
                var diversified = [];
                var roundRobinIdx = 0;
                while ( diversified.length < filtered.length )
                {
                    var currentType = typeOrder[roundRobinIdx % typeOrder.length];
                    if ( typeGroups[currentType].length > 0 )
                    {
                        diversified.push(typeGroups[currentType].shift());
                    }
                    roundRobinIdx++;
                    var hasMore = false;
                    for (var check = 0; check < typeOrder.length; check++)
                    {
                        if ( typeGroups[typeOrder[check]].length > 0 )
                        {
                            hasMore = true;
                            break;
                        }
                    }
                    if ( !hasMore ) break;
                }
                filtered = diversified;
            }

            console.log( "[Recs Debug] Category:", categoryHandle, "| After diversity:", filtered.length, "products" );
            for ( var logFinal = 0; logFinal < Math.min( filtered.length, 8 ); logFinal++ )
            {
                console.log( "  [" + logFinal + "]", filtered[logFinal].title, "| vendor:", filtered[logFinal].vendor );
            }

            for (var s = 0; s < filtered.length; s++)
            {
                shownProductIds[filtered[s].id] = true;
            }

            var countEl = document.querySelector(".quiz-areas-pick-count[data-category=\"" + categoryHandle + "\"]");

            if (countEl)
            {
                countEl.textContent = filtered.length;
            }

            if (filtered.length == 0)
            {
                panel.setAttribute("data-loaded", "true");
                productsContainer.innerHTML = "<p class=\"healthy-home-panel-empty\">No matching products found</p>";
                fetchUncoveredPickCounts();
                return;
            }

            var displayLimit = 15;
            var displayed = filtered.length > displayLimit ? displayLimit : filtered.length;

            var sliderHtml = "<div class=\"healthy-home-product-slider\">";
            sliderHtml += "<div class=\"healthy-home-product-slider-track\">";

            for (var i = 0; i < displayed; i++)
            {
                sliderHtml += renderHealthyHomeProductCard(filtered[i], quizTags);
            }

            sliderHtml += "</div>";
            sliderHtml += "</div>";
            productsContainer.innerHTML = sliderHtml;

            bindAtcButtons(productsContainer);
            bindPickedButtons(productsContainer);
            fetch("/cart.js", { method: "GET", headers: { "Accept": "application/json" } })
                .then(function FreshCart_QtyState(response) { return response.json(); })
                .then(function FreshCart_QtyState_Apply(freshCart)
                {
                    if (freshCart && freshCart.items && window.Shopify && window.Shopify.cart)
                    {
                        window.Shopify.cart = freshCart;
                    }
                    checkCartQtyState(productsContainer);
                })
                .catch(function FreshCart_QtyState_Fallback() { checkCartQtyState(productsContainer); });
            fetchUncoveredPickCounts();
            } );

        }

        var ecWidgetName = healthyHomeEcWidgets[ categoryHandle ] || "";

        if ( ecWidgetName )
        {
            console.log( "[Recs Debug] Category:", categoryHandle, "| Source: EC widget", ecWidgetName );
            loadEcPoolIntoPanel( panel, ecWidgetName, function EcPool_Ready( ecErr, ecProducts )
            {
                if ( !ecErr && ecProducts && ecProducts.length > 0 )
                {
                    console.log( "[Recs Debug] Category:", categoryHandle, "| EC pool:", ecProducts.length, "products" );
                    panel.setAttribute( "data-ec-pool", "1" );
                    HealthyHomeFetch_Products( null, ecProducts );
                }
                else
                {
                    console.log( "[Recs Debug] Category:", categoryHandle, "| EC empty, hardcoded fallback" );
                    panel.removeAttribute( "data-ec-pool" );
                    fetchCollectionProducts( categoryHandle, HealthyHomeFetch_Products );
                }
            } );
        }
        else
        {
            console.log( "[Recs Debug] Category:", categoryHandle, "| Source: hardcoded products.json" );
            fetchCollectionProducts( categoryHandle, HealthyHomeFetch_Products );
        }
    }
}

function getEcSessionId( )
{
    var sid = "";

    try
    {
        sid = window.localStorage.getItem( "EC_SID" ) || "";
    }
    catch ( e )
    {
        sid = "";
    }

    return sid;
}

function widgetNameForRecContainer( container )
{
    var name     = "";
    var panel    = null;
    var category = "";

    if ( container )
    {
        if ( container.getAttribute( "data-collection" ) == "members-love" )
        {
            name = "Cart Rec - Members";
        }
        else if ( container.closest( ".we-shop-similar-body" ) )
        {
            name = "PAB";
        }
        else if ( container.hasAttribute( "data-recent-track" ) || container.closest( "[data-recent-track]" ) )
        {
            name = "recent";
        }
        else
        {
            panel = container.closest( ".healthy-home-panel" );

            if ( panel )
            {
                category = panel.getAttribute( "data-category" ) || "";
                name     = healthyHomeEcWidgets[ category ] || "";
            }
        }
    }

    return name;
}

function trackEcAtcClick( widgetName, variantId )
{
    var event = null;

    if ( widgetName != "" && variantId && window._enhancedCommerceQ )
    {
        event = { "eventType" : "add_to_cart", "variantID" : String( variantId ), "widgetName" : widgetName };
        window._enhancedCommerceQ.push( { "command" : "track", "event" : event } );
    }
}

function bindAtcButtons(container)
{
    var buttons = container.querySelectorAll(".healthy-home-product-card-atc");

    for (var i = 0; i < buttons.length; i++)
    {
        buttons[i].addEventListener("click", function HealthyHomeAtc_Click(e)
        {
            e.preventDefault();

            var btn       = e.currentTarget;
            var variantId = btn.getAttribute("data-variant-id");
            var recWidgetName = widgetNameForRecContainer( container );
            var ecSid = getEcSessionId( );

            if (variantId)
            {
                btn.classList.add("healthy-home-product-card-atc--loading");

                var params = "id=" + variantId + "&quantity=1";

                if ( recWidgetName != "" )
                {
                    params += "&properties[_ec_widget]=" + encodeURIComponent( recWidgetName );

                    if ( ecSid != "" )
                    {
                        params += "&properties[_enhancedcommerce]=" + encodeURIComponent( ecSid );
                    }
                }

                fetch("/cart/add.js?sections=cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template,welleasy-new-old-cart", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Accept": "application/json"
                    },
                    body: params
                })
                .then(function HealthyHomeAtc_Response(response)
                {
                    if (!response.ok) { throw new Error("Add to cart failed"); }

                    return response.json();
                })
                .then(function HealthyHomeAtc_Success(cart)
                {
                    btn.classList.remove("healthy-home-product-card-atc--loading");
                    trackEcAtcClick( recWidgetName, btn.getAttribute( "data-variant-id" ) );

                    var card = btn.closest(".healthy-home-product-card");

                    if (card)
                    {
                        card.classList.add("has-qty");
                        renderQtySelector(card, 1, variantId);
                    }

                    refreshShopifyCartSnapshot(cart);
                    updateCartDrawer(cart);

                    if (cart && cart.items)
                    {
                        recheckAllRecsQtyState();
                    }
                    else
                    {
                        fetch("/cart.js", { method: "GET", headers: { "Accept": "application/json" } })
                            .then(function(r) { return r.json(); })
                            .then(function(freshCart)
                            {
                                if (freshCart && freshCart.items && window.Shopify && window.Shopify.cart)
                                {
                                    window.Shopify.cart = freshCart;
                                }
                                recheckAllRecsQtyState();
                            })
                            .catch(function() { recheckAllRecsQtyState(); });
                    }
                })
                .catch(function HealthyHomeAtc_Error()
                {
                    btn.classList.remove("healthy-home-product-card-atc--loading");
                });
            }
        });
    }
}

function checkCartQtyState(container)
{
    var cartItems = getCartItems();

    if (cartItems.length > 0)
    {
        var cards = container.querySelectorAll(".healthy-home-product-card");

        for (var i = 0; i < cards.length; i++)
        {
            var card   = cards[i];
            var atcBtn = card.querySelector(".healthy-home-product-card-atc");

            if (atcBtn)
            {
                var variantId = atcBtn.getAttribute("data-variant-id");

                if (variantId)
                {
                    for (var j = 0; j < cartItems.length; j++)
                    {
                        if (String(cartItems[j].variant_id) == variantId && cartItems[j].quantity > 0)
                        {
                            card.classList.add("has-qty");
                            renderQtySelector(card, cartItems[j].quantity, variantId);
                        }
                    }
                }
            }
        }
    }
}

function renderQtySelector(card, qty, variantId)
{
    var imageContainer = card.querySelector(".healthy-home-product-card-image");

    if (imageContainer)
    {
        var existing = imageContainer.querySelector(".healthy-home-product-card-qty");

        if (existing) { existing.remove(); }

        var trashSvg = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3 6h18\"></path><path d=\"M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6\"></path><path d=\"M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2\"></path><line x1=\"10\" x2=\"10\" y1=\"11\" y2=\"17\"></line><line x1=\"14\" x2=\"14\" y1=\"11\" y2=\"17\"></line></svg>";
        var minusSvg  = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5 12h14\"></path></svg>";
        var plusSvg   = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5 12h14\"></path><path d=\"M12 5v14\"></path></svg>";

        var leftIcon  = qty == 1 ? trashSvg : minusSvg;
        var leftLabel = qty == 1 ? "Remove from cart" : "Decrease quantity";

        var html = "<div class=\"healthy-home-product-card-qty\">";
        html += "<button type=\"button\" aria-label=\"" + leftLabel + "\" data-action=\"minus\">" + leftIcon + "</button>";
        html += "<span>" + qty + "</span>";
        html += "<button type=\"button\" aria-label=\"Increase quantity\" data-action=\"plus\">" + plusSvg + "</button>";
        html += "</div>";

        imageContainer.insertAdjacentHTML("beforeend", html);

        var minusBtn = imageContainer.querySelector(".healthy-home-product-card-qty [data-action=\"minus\"]");
        var plusBtn  = imageContainer.querySelector(".healthy-home-product-card-qty [data-action=\"plus\"]");

        minusBtn.addEventListener("click", function HandleQtyMinus()
        {
            handleQtyMinus(card, variantId);
        });

        plusBtn.addEventListener("click", function HandleQtyPlus()
        {
            handleQtyPlus(card, variantId);
        });
    }
}

function handleQtyMinus(card, variantId)
{
    var qtyEl      = card.querySelector(".healthy-home-product-card-qty span");
    var currentQty = parseInt(qtyEl.textContent, 10);

    if (currentQty <= 1)
    {
        removeItemFromCart(card, variantId);
    }
    else
    {
        var newQty = currentQty - 1;
        updateCartItemQty(card, variantId, newQty, qtyEl);
    }
}

function handleQtyPlus(card, variantId)
{
    var qtyEl      = card.querySelector(".healthy-home-product-card-qty span");
    var currentQty = parseInt(qtyEl.textContent, 10);
    var newQty     = currentQty + 1;

    updateCartItemQty(card, variantId, newQty, qtyEl);
}

function updateCartItemQty(card, variantId, newQty, qtyEl)
{
    var params = "id=" + variantId + "&quantity=" + newQty + "&sections=cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template,welleasy-new-old-cart";

    fetch("/cart/change.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Accept": "application/json"
        },
        body: params
    })
    .then(function HealthyHomeUpdateQtyResponse(response)
    {
        if (!response.ok) { throw new Error("Update cart failed"); }

        return response.json();
    })
    .then(function HealthyHomeUpdateQtySuccess(cart)
    {
        qtyEl.textContent = newQty;
        renderQtySelector(card, newQty, variantId);
        refreshShopifyCartSnapshot(cart);

        updateCartDrawer(cart);
        recheckAllRecsQtyState();
    })
    .catch(function HealthyHomeUpdateQtyError() {});
}

function removeItemFromCart(card, variantId)
{
    var params = "id=" + variantId + "&quantity=0&sections=cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template,welleasy-new-old-cart";

    fetch("/cart/change.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Accept": "application/json"
        },
        body: params
    })
    .then(function HealthyHomeRemoveItemResponse(response)
    {
        if (!response.ok) { throw new Error("Remove from cart failed"); }

        return response.json();
    })
    .then(function HealthyHomeRemoveItemSuccess(cart)
    {
        card.classList.remove("has-qty");

        var qtyEl = card.querySelector(".healthy-home-product-card-qty");

        if (qtyEl) { qtyEl.remove(); }

        refreshShopifyCartSnapshot(cart);

        updateCartDrawer(cart);
        recheckAllRecsQtyState();
    })
    .catch(function HealthyHomeRemoveItemError() {});
}

function updateCartSummary(cart)
{
    var subtotalEl = document.querySelector(".welleasy-redesigned-cart .subtotal-amount strong");

    if (subtotalEl && cart.items_subtotal_price != undefined)
    {
        subtotalEl.innerHTML = Shopify.formatMoney(cart.items_subtotal_price);
    }

    var itemCountEl = document.querySelector(".welleasy-redesigned-cart .item-count");

    if (itemCountEl && cart.item_count != undefined)
    {
        itemCountEl.textContent = cart.item_count + " items";
    }

    var groceryBoxPrice = document.querySelector(".welleasy-redesigned-cart .grocery-box-price");

    if (groceryBoxPrice && cart.items_subtotal_price != undefined)
    {
        if (cart.items_subtotal_price >= 3900)
        {
            groceryBoxPrice.textContent = "FREE";
        }
        else
        {
            var defaultPrice = groceryBoxPrice.getAttribute("data-default-price") || "£4.99";
            groceryBoxPrice.textContent = defaultPrice;
        }
    }

    var progressBar  = document.querySelector(".welleasy-redesigned-cart .cart-delivery-progress-bar");
    var progressInfo = document.querySelector(".welleasy-redesigned-cart .cart-delivery-progress-info");

    if (progressBar && cart.items_subtotal_price != undefined)
    {
        var freeDeliveryCriteria = 3900;
        var freeDeliveryDiff     = freeDeliveryCriteria - cart.items_subtotal_price;

        if (freeDeliveryDiff <= 0)
        {
            progressBar.setAttribute("data-progress-width", "100%");

            var innerBar = progressBar.querySelector(".cart-delivery-progress-bar-inner");

            if (innerBar) { innerBar.style.width = "100%"; }

            if (progressInfo) { progressInfo.innerHTML = "<p>You qualify for free delivery</p>"; }
        }
        else
        {
            var progress    = Math.min(100, (cart.items_subtotal_price / freeDeliveryCriteria) * 100);
            var innerBar    = progressBar.querySelector(".cart-delivery-progress-bar-inner");

            progressBar.setAttribute("data-progress-width", progress + "%");

            if (innerBar) { innerBar.style.width = progress + "%"; }

            if (progressInfo) { progressInfo.innerHTML = "<p>Add <strong>" + Shopify.formatMoney(freeDeliveryDiff) + "</strong> for <strong>FREE shipping</strong></p>"; }
        }
    }

    var savingsEl = document.querySelector(".welleasy-redesigned-cart .order-savings-breakdown");

    if (savingsEl)
    {
        var memberSavingsRow = savingsEl.querySelector(".member-savings-row");
        var autoshipRow      = savingsEl.querySelector(".autoship-savings-row");

        if (memberSavingsRow) { memberSavingsRow.style.display = "none"; }
        if (autoshipRow) { autoshipRow.style.display = "none"; }
    }

    refreshCartItems();
}

function refreshCartItems()
{
    var container = document.querySelector(".cart-products-items-container");

    if (container)
    {
        var sectionName = getActiveCartSectionName();

        fetch("/?sections=" + sectionName, {
            method: "GET",
            headers: { "Accept": "application/json" }
        })
        .then(function RefreshCart_Response(response)
        {
            if (!response.ok) { throw new Error("Failed to refresh cart"); }

            return response.json();
        })
        .then(function RefreshCart_Apply(data)
        {
            var sectionHtml = data[sectionName];

            if (sectionHtml)
            {
                var parser     = new DOMParser();
                var doc        = parser.parseFromString(sectionHtml, "text/html");
                var newContainer = doc.querySelector(".cart-products-items-container");

                if (newContainer)
                {
                    container.innerHTML = newContainer.innerHTML;
                    bindAtcButtons(container);
                    bindPickedButtons(container);
                    checkCartQtyState(container);
                    checkHealthyHomeCategories();
                }
            }
        })
        .catch(function RefreshCartError() {});
    }
}

function initHealthyHomeRecommendations(skipQuizFilter)
{
    var now = Date.now();
    if ( window._lastInitRecs && ( now - window._lastInitRecs ) < 300 )
    {
        return;
    }
    window._lastInitRecs = now;

    shownProductIds = {};

    initHealthyHomeTabListeners();
    initQuizAreasTagListeners();

    var panels = document.querySelectorAll(".healthy-home-panel:not(.hidden)");

    for ( var i = 0; i < panels.length; i++ )
    {
        if ( !panels[i].getAttribute("data-loaded") )
        {
            loadProductsForPanel(panels[i], skipQuizFilter);
            break;
        }
    }
}

function initAll()
{
    initHealthyHomeRecommendations();
    loadMembersLove();
}

function isDocumentReady()
{
    return document.readyState != "loading";
}

if (isDocumentReady())
{
    initAll();
}
else
{
    document.addEventListener("DOMContentLoaded", initAll);
}

if (window.Shopify && window.Shopify.events)
{
    window.Shopify.events.on("cart:change", handleCartChange);
}

function handleCartChange()
{
    checkHealthyHomeCategories();
}

function removeMemberFreeGifts( callback )
{
    var isMember = document.body.classList.contains( "has-inveterate-subscriber" );
    if ( !isMember )
    {
        callback();
        return;
    }

    fetch( "/cart.js", { method: "GET", headers: { "Accept": "application/json" } } )
        .then( function( r ) { return r.json(); } )
        .then( function( cart )
        {
            var giftItems = [];
            for ( var i = 0; i < cart.items.length; i++ )
            {
                var props = cart.items[ i ].properties;
                if ( props && props._product_gift_type == "free_gift" )
                {
                    giftItems.push( cart.items[ i ].key );
                }
            }

            if ( giftItems.length == 0 )
            {
                callback();
                return;
            }

            var removed = 0;
            for ( var j = 0; j < giftItems.length; j++ )
            {
                fetch( "/cart/change.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify( { id: giftItems[ j ], quantity: 0 } )
                } )
                .then( function()
                {
                    removed++;
                    if ( removed == giftItems.length )
                    {
                        callback();
                    }
                } );
            }
        } )
        .catch( callback );
}

function loadMembersLove()
{
    var container = document.querySelector(".members-love-products");

    if (container && !container.getAttribute("data-loaded"))
    {
        var collectionHandle = container.getAttribute("data-collection") || "quiz-best-sellers-non-basics";
        var quizTags          = getQuizTags();

        removeMemberFreeGifts( function()
        {
            fetch( "/cart.js", { method: "GET", headers: { "Accept": "application/json" } } )
                .then( function( r ) { return r.json(); } )
                .then( function( freshCart ) { renderMembersLove( freshCart.items || [], collectionHandle, quizTags, container ); } )
                .catch( function() { renderMembersLove( [], collectionHandle, quizTags, container ); } );
        } );
    }
}

function renderMembersLove( mlCartItems, collectionHandle, quizTags, container )
{
        function MembersLove_Fetch(err, products)
        {
            if (err || products.length == 0)
            {
                container.innerHTML = "<p class=\"healthy-home-panel-empty\">No products found</p>";
                return;
            }

            container.setAttribute("data-loaded", "true");
            window._membersLoveLoaded = true;

            var mlCartHandles = [];
            for (var mci = 0; mci < mlCartItems.length; mci++)
            {
                var h = mlCartItems[mci].handle || ( mlCartItems[mci].url && mlCartItems[mci].url.split( "/products/" )[ 1 ] );
                if ( h )
                {
                    mlCartHandles.push( h );
                }
            }
            var mlNonCartProducts = [];
            for (var mpi = 0; mpi < products.length; mpi++)
            {
                if (mlCartHandles.indexOf(products[mpi].handle) == -1)
                {
                    mlNonCartProducts.push(products[mpi]);
                }
            }
            products = mlNonCartProducts;

            var filtered = [];

            for (var i = 0; i < products.length; i++)
            {
                var uv = products[i].variants && products[i].variants.length > 0 ? products[i].variants[0] : null;

                if (uv && uv.available && productMatchesQuizTags(products[i], quizTags))
                {
                    if (!shownProductIds[products[i].id])
                    {
                        filtered.push(products[i]);
                        shownProductIds[products[i].id] = true;
                    }
                }
            }

            buildL3ProductMap( function OnMembersLoveL3Map( l3Map )
            {
                if ( container.getAttribute( "data-ec-pool" ) == "1" )
                {
                    console.log( "[Recs Debug] Members Love | L3 cap skipped (EC pool)" );
                }
                else
                {
                    filtered = applyL3Cap( filtered, l3Map, buildL3ProductMap._limits || [] );
                }

                console.log( "[Recs Debug] Members Love | After L3 cap:", filtered.length, "products" );

            if (filtered.length == 0)
            {
                container.innerHTML = "<p class=\"healthy-home-panel-empty\">No matching products found</p>";
                return;
            }

            var html = "<div class=\"healthy-home-product-slider\">";
            html += "<div class=\"healthy-home-product-slider-track\">";

            var displayLimit = 25;
            var displayed = filtered.length > displayLimit ? displayLimit : filtered.length;

            for (var i = 0; i < displayed; i++)
            {
                html += renderHealthyHomeProductCard(filtered[i], quizTags);
            }

            html += "</div>";
            html += "</div>";
            container.innerHTML = html;

            bindAtcButtons(container);
            bindPickedButtons(container);
            fetch("/cart.js", { method: "GET", headers: { "Accept": "application/json" } })
                .then(function FreshCart_ML_QtyState(response) { return response.json(); })
                .then(function FreshCart_ML_QtyState_Apply(freshCart)
                {
                    if (freshCart && freshCart.items && window.Shopify && window.Shopify.cart)
                    {
                        window.Shopify.cart = freshCart;
                    }
                    checkCartQtyState(container);
                })
                .catch(function FreshCart_ML_QtyState_Fallback() { checkCartQtyState(container); });
            } );

        }

        loadEcPoolIntoPanel( container, "Cart Rec - Members", function MembersLove_EcReady( ecErr, ecProducts )
        {
            if ( !ecErr && ecProducts && ecProducts.length > 0 )
            {
                console.log( "[Recs Debug] Members Love | EC pool:", ecProducts.length, "products" );
                container.setAttribute( "data-ec-pool", "1" );
                MembersLove_Fetch( null, ecProducts );
            }
            else
            {
                console.log( "[Recs Debug] Members Love | EC empty, hardcoded fallback" );
                container.removeAttribute( "data-ec-pool" );
                fetchCollectionProducts( collectionHandle, MembersLove_Fetch );
            }
        } );
}

function buildL3ProductMap( callback )
{
    if ( !buildL3ProductMap._cache && !buildL3ProductMap._building )
    {
        var cached = null;

        try
        {
            var raw = localStorage.getItem( "welleasy_l3_map" );
            var cachedTime = localStorage.getItem( "welleasy_l3_map_time" );

            if ( raw && cachedTime )
            {
                var age = Date.now() - parseInt( cachedTime, 10 );

                if ( age < 86400000 )
                {
                    cached = JSON.parse( raw );
                }
            }
        }
        catch ( e ) {}

        if ( cached )
        {
            buildL3ProductMap._cache = cached;
            callback( cached );
            return;
        }

        buildL3ProductMap._building = true;
        buildL3ProductMap._queue = [];
        buildL3ProductMap._limits = [
            { handle: "olive-oil", limit: 1 },
            { handle: "coconut-oil", limit: 1 },
            { handle: "avocado-oil", limit: 1 },
            { handle: "ghee", limit: 1 },
            { handle: "tallow", limit: 1 },
            { handle: "vinegars", limit: 1 },
            { handle: "beans-legumes", limit: 2 },
            { handle: "meat-seafood", limit: 2 },
            { handle: "broths-stocks", limit: 2 },
            { handle: "pickled-fermented-foods", limit: 1 },
            { handle: "olives-antipasti", limit: 1 },
            { handle: "coconut-milk-cream", limit: 1 },
            { handle: "soups", limit: 1 },
            { handle: "chopped-tomatoes-purees", limit: 1 },
            { handle: "pasta-sauces", limit: 2 },
            { handle: "mayonnaise", limit: 1 },
            { handle: "ketchup", limit: 1 },
            { handle: "mustard", limit: 1 },
            { handle: "soy-sauce-tamari", limit: 1 },
            { handle: "cooking-sauces-marinades", limit: 1 },
            { handle: "dips-salsa", limit: 1 },
            { handle: "hot-sauce", limit: 1 },
            { handle: "cereals", limit: 2 },
            { handle: "granola-muesli", limit: 2 },
            { handle: "porridge-oats", limit: 1 },
            { handle: "fruit-spreads", limit: 1 },
            { handle: "honey", limit: 1 },
            { handle: "almond-butter", limit: 1 },
            { handle: "peanut-butter", limit: 1 },
            { handle: "chocolate-sweet-spreads", limit: 1 },
            { handle: "maple-syrup", limit: 1 },
            { handle: "high-protein-cereal", limit: 1 },
            { handle: "bread", limit: 2 },
            { handle: "dry-packaged-rice", limit: 1 },
            { handle: "dry-packaged-grains", limit: 1 },
            { handle: "pasta", limit: 1 },
            { handle: "gluten-free-pasta", limit: 2 },
            { handle: "gluten-free-bread", limit: 1 },
            { handle: "chia-seeds", limit: 1 },
            { handle: "dates", limit: 1 },
            { handle: "almonds", limit: 1 },
            { handle: "cashews", limit: 1 },
            { handle: "pumpkin-seeds-500g", limit: 1 },
            { handle: "walnuts", limit: 1 },
            { handle: "mango", limit: 1 },
            { handle: "chocolate-covered-nuts-fruit", limit: 2 },
            { handle: "flour-meal", limit: 1 },
            { handle: "sugar", limit: 1 },
            { handle: "sugar-alternatives", limit: 1 },
            { handle: "baking-mixes", limit: 1 },
            { handle: "cooking-chocolate-cocoa", limit: 1 },
            { handle: "crisps-popcorn", limit: 2 },
            { handle: "meat-snacks", limit: 2 },
            { handle: "chocolate", limit: 2 },
            { handle: "snacks-bars", limit: 2 },
            { handle: "protein-snacks", limit: 2 },
            { handle: "crackers-rice-cakes", limit: 2 },
            { handle: "cookies-biscuits", limit: 2 },
            { handle: "coffee", limit: 1 },
            { handle: "tea", limit: 1 },
            { handle: "kombucha", limit: 2 },
            { handle: "coconut-water", limit: 1 },
            { handle: "soft-drinks", limit: 2 },
            { handle: "juices", limit: 1 },
            { handle: "matcha", limit: 1 },
            { handle: "almond-milk", limit: 1 },
            { handle: "oat-milk", limit: 1 },
            { handle: "hot-chocolate", limit: 1 },
            { handle: "water-sparkling-water", limit: 1 },
            { handle: "vitamin-c", limit: 1 },
            { handle: "vitamin-d", limit: 1 },
            { handle: "vitamin-b", limit: 1 },
            { handle: "omegas-fish-oils", limit: 1 },
            { handle: "probiotics-prebiotics", limit: 1 },
            { handle: "magnesium", limit: 1 },
            { handle: "protein-powders", limit: 1 },
            { handle: "collagen", limit: 1 },
            { handle: "superfoods-greens", limit: 1 },
            { handle: "mushrooms", limit: 1 },
            { handle: "minerals", limit: 1 },
            { handle: "electrolytes", limit: 1 },
            { handle: "herbs-formulas", limit: 1 },
            { handle: "multipurpose-cleaners", limit: 1 },
            { handle: "bathroom-cleaners", limit: 1 },
            { handle: "dishwashing", limit: 1 },
            { handle: "toilet-roll", limit: 1 },
            { handle: "laundry-detergents", limit: 1 },
            { handle: "fabric-conditioners", limit: 1 },
            { handle: "bin-bags", limit: 1 },
            { handle: "sponges-cloths-wipes", limit: 1 },
            { handle: "hair-care", limit: 1 },
            { handle: "body-wash-scrubs", limit: 1 },
            { handle: "oral-care", limit: 1 },
            { handle: "deodorant", limit: 1 },
            { handle: "moisturisers-oils", limit: 1 },
            { handle: "womens-hygiene", limit: 1 }
        ];

        var map = {};
        var loaded = 0;
        var total = buildL3ProductMap._limits.length;
        var mapDone = false;

        function OnL3FetchDone()
        {
            if ( mapDone )
            {
                return;
            }

            loaded++;

            if ( loaded >= total )
            {
                mapDone = true;
                buildL3ProductMap._cache = map;

                try
                {
                    localStorage.setItem( "welleasy_l3_map", JSON.stringify( map ) );
                    localStorage.setItem( "welleasy_l3_map_time", String( Date.now() ) );
                }
                catch ( e ) {}

                buildL3ProductMap._building = false;
                callback( map );

                for ( var q = 0; q < buildL3ProductMap._queue.length; q++ )
                {
                    buildL3ProductMap._queue[ q ]( map );
                }

                buildL3ProductMap._queue = [];
            }
        }

        setTimeout( function L3Map_GuardTimeout()
        {
            if ( !mapDone )
            {
                loaded = total;
                OnL3FetchDone();
            }
        }, 15000 );

        for ( var i = 0; i < total; i++ )
        {
            ( function FetchOneL3( limit )
            {
                fetch( "/collections/" + limit.handle + "/products.json?limit=250" )
                    .then( function OnL3Response( r ) { return r.json(); } )
                    .then( function OnL3Data( data )
                    {
                        var prods = data.products || [];

                        for ( var p = 0; p < prods.length; p++ )
                        {
                            map[ prods[ p ].id ] = limit.handle;
                        }

                        OnL3FetchDone();
                    } )
                    .catch( function OnL3Error() { OnL3FetchDone(); } );
            } )( buildL3ProductMap._limits[ i ] );
        }
    }
    else if ( buildL3ProductMap._cache )
    {
        callback( buildL3ProductMap._cache );
    }
    else
    {
        buildL3ProductMap._queue.push( callback );
    }
}

function applyL3Cap( products, l3Map, limits )
{
    var l3Counts = {};
    var capped = [];

    for ( var i = 0; i < products.length; i++ )
    {
        var l3 = l3Map[ products[ i ].id ];

        if ( !l3 )
        {
            capped.push( products[ i ] );
        }
        else
        {
            if ( !l3Counts[ l3 ] )
            {
                l3Counts[ l3 ] = 0;
            }

            var maxForL3 = 1;

            for ( var j = 0; j < limits.length; j++ )
            {
                if ( limits[ j ].handle == l3 )
                {
                    maxForL3 = limits[ j ].limit;
                    break;
                }
            }

            if ( l3Counts[ l3 ] < maxForL3 )
            {
                capped.push( products[ i ] );
                l3Counts[ l3 ]++;
            }
        }
    }

    return capped;
}
